import { forwardRef, HTMLAttributes, useImperativeHandle, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import SVGIcon from '@/components/base/svg-icon'

import { cn } from '@/lib/utils'

export type TransitionMaskProps = HTMLAttributes<HTMLDivElement>

export type TransitionMaskHandler = {
  enterTimeline: () => GSAPTimeline
  leaveTimeline: () => GSAPTimeline
  resetTimeline: () => void
}

const TransitionMask = forwardRef<TransitionMaskHandler>((_, ref) => {
  const root = useRef<HTMLDivElement>(null)
  const { contextSafe } = useGSAP({ scope: root })

  const enterTimeline = contextSafe(() =>
    gsap
      .timeline()
      .set(root.current, { yPercent: 100 })
      .fromTo(root.current, { opacity: 0 }, { opacity: 1, duration: 0.5, ease: 'power2.inOut' })
  )

  const leaveTimeline = contextSafe(() =>
    gsap
      .timeline()
      .set(root.current, { yPercent: 100 })
      .fromTo(root.current, { opacity: 1 }, { opacity: 0, duration: 0.5, ease: 'power2.inOut' })
      .set(root.current, { yPercent: 0 })
  )

  const resetTimeline = contextSafe(() => {
    gsap.set(root.current, { yPercent: 100 })
  })

  useImperativeHandle(
    ref,
    () => ({
      leaveTimeline,
      enterTimeline,
      resetTimeline
    }),
    [enterTimeline, leaveTimeline, resetTimeline]
  )

  return (
    <div
      ref={root}
      className={cn(
        'fixed -top-full left-0 z-transition size-full bg-white',
        'flex items-center justify-center'
      )}
    >
      <SVGIcon symbol="logo-full" className="h-[4.8rem] w-full max-w-[24.5rem] opacity-0" />
    </div>
  )
})

export default TransitionMask
